import React from 'react';

const LoadingSpinner = ({ size = 'medium', color = 'blue' }) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        medium: 'w-8 h-8',
        large: 'w-12 h-12'
    };

    const colorClasses = {
        blue: 'border-blue-500',
        white: 'border-white',
        gray: 'border-gray-500'
    };

    return (
        <div className="flex items-center justify-center p-4">
            <div className={`
                ${sizeClasses[size]} 
                ${colorClasses[color]}
                border-4 border-t-transparent rounded-full animate-spin
            `}></div>
        </div>
    );
};

export default LoadingSpinner; 